
define('text!modules/creatives/templates/violationFilterSearch.html',[],function () { return '<div class="search">\n  <strand-input class="txt" search clear placeholder="Search" layout="dropdown"></strand-input>\n</div>\n';});

